import { useEffect, useState } from "react";
import { Button, TextInput, useNotify, useRecordContext, useRefresh, required, maxLength } from "react-admin";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { Box, FormControl, FormGroup, FormControlLabel, Grid, Typography, Switch } from "@mui/material";
import FormModal from "server/components/Modals/FormModal";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { studentRequests } from "api/studentApi";
import dataProvider from "server/dataProvider";

const HealthInsuranceModal = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  const [userData, setUserData] = useState(null);
  const [state, setState] = useState({
    HasEmploymentIncome: false,
    ReceivesSurvivorPension: false,
    HasOtherTaxableHealthIncome: false,
  });

  const fetchStatus = async () => {
    try {
      const { data } = await dataProvider.customRequest(
        studentRequests.getStudentHealthCareStatus(record.studentId),
        null,
        "GET",
      );
      setUserData(data || null);
    } catch {
      notify("Няма намерени резултати за този студент!", { type: "error" });
    }
  };

  useEffect(() => {
    if (!userData) return;

    setState({
      HasEmploymentIncome: userData.healthInsuranceParams?.includes("HasEmploymentIncome") || false,
      ReceivesSurvivorPension: userData.healthInsuranceParams?.includes("ReceivesSurvivorPension") || false,
      HasOtherTaxableHealthIncome: userData.healthInsuranceParams?.includes("HasOtherTaxableHealthIncome") || false,
    });
  }, [userData]);

  const handleChange = event => {
    setState(prev => ({
      ...prev,
      [event.target.name]: event.target.checked,
    }));
  };

  const resetState = () => {
    setUserData(null);
    setState({
      HasEmploymentIncome: false,
      ReceivesSurvivorPension: false,
      HasOtherTaxableHealthIncome: false,
    });
  };

  const handleConfirm = async data => {
    const payload = {
      startDate: data.startDate,
      identityNumber: data.identityNumber,
      healthInsuranceParams: Object.keys(state).filter(key => state[key]),
    };
    await dataProvider.customRequest(studentRequests.updateStudentHealthCareStatus(record.studentId), payload, "PUT");
    notify("Успешно направена редакция", { type: "success" });
    refresh();
  };

  return (
    <div style={{ display: "inline-flex", alignItems: "center", verticalAlign: "middle" }}>
      <Box
        display="flex"
        justifyContent="flex-end"
      >
        <FormModal
          triggerButton={
            <Button
              variant="contained"
              startIcon={<ModeEditIcon />}
              label="Редакция"
            />
          }
          onOpen={fetchStatus}
          titleContent="Редакция на здравно осигуряване"
          saveTitle="Запази"
          closeTitle="Откажи"
          onConfirm={handleConfirm}
          resetProps={resetState}
          defaultValues={{ identityNumber: userData?.identityNumber ?? null, startDate: null }}
          dialogProps={{ fullWidth: true }}
        >
          <Grid
            container
            direction="column"
          >
            <Grid item>
              <Typography
                color="primary"
                fontSize={18}
                textAlign="center"
                fontWeight="bold"
              >
                Възраст: <span style={{ color: "black" }}>{userData?.studentAge} г.</span>
              </Typography>
            </Grid>

            <Grid
              item
              mb={4}
            >
              <Typography
                color="primary"
                fontSize={18}
                textAlign="center"
                fontWeight="bold"
              >
                Рождена дата: <span style={{ color: "black" }}>{userData?.studentBirthDate}</span>
              </Typography>
            </Grid>
            {userData?.shouldEnterIdentityNumber ? (
              <Grid
                item
                xs={9}
              >
                <TextInput
                  source="identityNumber"
                  label={"Допълнителен идентификационен номер"}
                  validate={[required("Задължително"), maxLength(50)]}
                  fullWidth
                />
              </Grid>
            ) : null}
            <Grid
              item
              xs={9}
              mb={4}
            >
              <CustomDateInput
                label="Влиза в сила от"
                source="startDate"
                validate={required("Моля попълнете дата!")}
              />
            </Grid>

            <Grid item>
              <FormControl component="fieldset">
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={state.HasEmploymentIncome}
                        onChange={handleChange}
                        name="HasEmploymentIncome"
                      />
                    }
                    label="Получавам доходи от трудова дейност"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={state.ReceivesSurvivorPension}
                        onChange={handleChange}
                        name="ReceivesSurvivorPension"
                      />
                    }
                    label="Получавам наследствена пенсия"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={state.HasOtherTaxableHealthIncome}
                        onChange={handleChange}
                        name="HasOtherTaxableHealthIncome"
                      />
                    }
                    label="Получавам други доходи, върху които се дължат здравноосигурителни вноски по реда на чл.40, ал.1 от 330"
                  />
                </FormGroup>
              </FormControl>
            </Grid>
          </Grid>
        </FormModal>
      </Box>
    </div>
  );
};

export default HealthInsuranceModal;
